import React from "react";
import {Route, Switch} from "react-router-dom";
import GetFreightRateQuotationsList from "./GetFreightRateQuotationsLists";
import PostFreightRateQuotationsDetails from "./PostFreightRateQuotationsDetails";
import FreightRateQuotationsView from "./FreightRateQuotationsView";
import AdminQuotationList from "./AdminQuotationList";
import AdminQuotationDetails from "./AdminQuotationDetails";

const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={GetFreightRateQuotationsList}/>
      <Route path={`${match.url}/details/:id?`} component={PostFreightRateQuotationsDetails}/>
      <Route path={`${match.url}/view/:id?`} component={FreightRateQuotationsView}/>
      <Route path={`${match.url}/clone/:id?`} component={PostFreightRateQuotationsDetails}/>
      <Route path={`${match.url}/quotations-list/:id?`} component={AdminQuotationList}/>
      <Route path={`${match.url}/quotations-details/:id?`} component={AdminQuotationDetails}/>
    </Switch>
);

export default App;
